/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reduced_Frost_Free_TemperatureInputs */



/**
* | output |
* | --- |
* | "Frost-free reduction" |
*
* @param {Reduced_Frost_Free_TemperatureInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const reduced_frost_free_temperature = /** @type {((inputs?: Reduced_Frost_Free_TemperatureInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reduced_Frost_Free_TemperatureInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Frost-free reduction")
	return /** @type {LocalizedString} */ ("Réduit Hors Gel")
});